export default "__VITE_ASSET__CBV1v7j2__"